<template lang="pug">
transition(name="fade")
  .loading-icon(v-if="isLoading" @touchmove="onTouchMove")
    .lds-facebook
      div
      div
      div
</template>

<script>
import {mapState} from 'Vuex'
export default {
  props:{
  },
  components: {},
  data () {
    return {}
  },
  computed: {
    ...mapState('loading', {isLoading: 'isLoading'}),
  },
  methods: {
    onTouchMove(e){
      e.preventDefault();
    },
  },
  created () {},
  mounted () {
  },
}
</script>


<style lang="stylus" scoped>
.fade
  &-enter-active,
  &-leave-active
    transition opacity 0.3s ease;
  &-enter,
  &-leave-to
    opacity 0;
.loading-icon
  position fixed
  top calc(50% - 40px)
  left calc(50% - 40px)
  z-index 10
.lds-facebook {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-facebook div {
  display: inline-block;
  position: absolute;
  left: 8px;
  width: 16px;
  background: #fff;
  animation: lds-facebook 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
}
.lds-facebook div:nth-child(1) {
  left: 8px;
  animation-delay: -0.24s;
}
.lds-facebook div:nth-child(2) {
  left: 32px;
  animation-delay: -0.12s;
}
.lds-facebook div:nth-child(3) {
  left: 56px;
  animation-delay: 0;
}
@keyframes lds-facebook {
  0% {
    top: 8px;
    height: 64px;
  }
  50%, 100% {
    top: 24px;
    height: 32px;
  }
}
</style>
